import { CandleValidationApi, INTERVAL, interval_record_names } from '@voladeum/client';
import { FORMAT_TYPE } from 'cyprus/enums';
import { formatValue } from 'cyprus/formats';
import moment from 'moment';
import { v4 as uuidv4 } from 'uuid';

import { CandleValidation } from './types';

export const normalizeCandleValidations = (data: CandleValidationApi[]): CandleValidation[] =>
  data.map((d) => normalizeCandleValidation(d));

export const normalizeCandleValidation = (row: CandleValidationApi): CandleValidation => {
  const { minute_accuracy, hour_accuracy, day_accuracy } = row;
  const minute_percent = minute_accuracy / interval_record_names[INTERVAL.MINUTE];
  const hour_percent = hour_accuracy / interval_record_names[INTERVAL.HOUR];
  const day_percent = day_accuracy / interval_record_names[INTERVAL.DAY];

  return {
    ...row,
    since_date: moment(row.since_milliseconds).utc().format('MM/DD/YYYY'),
    to_date: moment(row.to_milliseconds).utc().format('MM/DD/YYYY'),
    minute_percent,
    minute_percent_formatted: formatValue(minute_percent, {
      format: FORMAT_TYPE.PERCENT,
      decimal: 2,
    }),
    minute_count_formatted: formatValue(row.minute_count, { format: FORMAT_TYPE.NUMBER }),
    minute_accuracy_formatted: formatValue(row.minute_accuracy, { format: FORMAT_TYPE.NUMBER }),
    hour_percent,
    hour_percent_formatted: formatValue(hour_percent, { format: FORMAT_TYPE.PERCENT, decimal: 2 }),
    hour_count_formatted: formatValue(row.hour_count, { format: FORMAT_TYPE.NUMBER }),
    hour_accuracy_formatted: formatValue(row.hour_accuracy, { format: FORMAT_TYPE.NUMBER }),
    day_percent,
    day_percent_formatted: formatValue(day_percent, { format: FORMAT_TYPE.PERCENT, decimal: 2 }),
    day_count_formatted: formatValue(row.day_count, { format: FORMAT_TYPE.NUMBER }),
    day_accuracy_formatted: formatValue(row.day_accuracy, { format: FORMAT_TYPE.NUMBER }),
    uuid: uuidv4(),
  };
};
